<div class="btn-group date-range-control-group">
  <button type="button" class="btn btn-light btn-prev" (click)="onPrev()">
    <i class="fal fa-angle-left"></i>
  </button>
  <div dropdown class="btn btn-light btn-range dropdown" role="button" container="body">
    <a dropdownToggle role="button" [title]="selectedDateRange?.label">
      {{selectedDateRange?.label}}
    </a>
    <ul *dropdownMenu class="dropdown-menu">
      <li *ngFor="let range of ranges;let idx = index" class="text-truncate"
          [ngClass]="{active: range.label === selectedDateRange.label}">
        <button (click)="onSelectDateRange(idx)" type="button">{{range.label}}</button>
      </li>
    </ul>
  </div>
  <button type="button" class="btn btn-light btn-next" (click)="onNext()">
    <i class="fal fa-angle-right"></i>
  </button>
</div>
